export enum RedirectEventTypes {
  VerifyMail = 'VerifyEmail', //
  BuyerExclusiveInvitation = 'BuyerExclusiveInvitation',
  BuyerAuctionCatalog = 'auctionCatalog', //
  SellerAskForMoreDocumentsFromBuyer = 'SellerAskForMoreDocumentsFromBuyer', //
  BuyerAcceptAuctionInvitation = 'BuyerAcceptAuctionInvitation', //
  ForgetPassword = 'ForgetPassword',
  Login = 'Login',
  AuctionItemProfile = 'AuctionItemProfile',
  BuyerToSellerApplication = 'BuyerToSellerApplication',
  SellerTermsAndConditions = 'SellerTermsAndConditions',
  BuyerHorseClaimer = 'buyerHorseClaimer',
  SellerBuyerApplication = 'sellerBuyerApplication',
  SellerInvoice = 'sellerInvoice',
  SellerOffers = 'SellerOffersPage',
}
